import { render, staticRenderFns } from "./singlePage.vue?vue&type=template&id=e5f38a0c"
import script from "./singlePage.vue?vue&type=script&lang=js"
export * from "./singlePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports